window.infoLineaProduccionSoplado = null;

if (window.location.pathname === "/soplado/periodo" || window.location.pathname === "/zona-trabajo") {
    
    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const modalEditarProduccion = document.querySelector("#formEditarProduccionSoplado");
    let idLineaProduccion = modalEditarProduccion.querySelector("#idLineaProduccionSoplado").value;
    
    window.infoLineaProduccionSoplado = (idLineaProduccion) => {
                
        const url = `/api/soplado/produccionSoplado?idLinea=${idLineaProduccion}`;

        const divModalEditar = document.querySelector("#contEditarProduccionSoplado");
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {

                divModalEditar.innerHTML = "";
                const data = result.result[0];
                const int = n => (Number(n) || 0).toLocaleString('en-US');
                const txt = t => String(t ?? "").trim();

                divModalEditar.innerHTML = `
                    <div class="contInfoProduccionIny  ${data.estadoEncabezadoReporteSoplado != 1 ? 'canvaBloqueado' : ''}">
                        <div class="infoProduccion">
                            <span class="labelInfoProduccion">Hora inicio:</span>
                            <input class="inputModal inputBloqueado" name="horaInicio" type="time" value="${data.horaInicio}" readonly>
                        </div>
                        <div class="infoProduccion">
                            <span class="labelInfoProduccion">Hora fin:</span>
                            <input class="inputModal inputBloqueado" name="horaFin" type="time" value="${data.horaFin}" readonly>
                        </div>
                        <div class="infoProduccion gridColum">
                            <span class="labelInfoProduccion">Total producción buena:</span>
                            <input class="inputModal formatoNumero" name="undsBuenas" type="text" value="${int(data.undsBuenas)}" placeholder="Ingresa producción buena">
                        </div>
                        <div class="infoProduccion txtAreaAgp">
                            <span class="labelInfoProduccion">Observaciones:</span>
                            <textarea class="txtAreaModal" name="observaciones" rows="6" maxlength="250" placeholder="Escribe las observaciones aquí...">${txt(data.observaciones)}</textarea>
                        </div>
                    </div>
                    <div class="contBtnModal">
                        ${data.estadoEncabezadoReporteSoplado == 1 ? `
                            <button id="btnEliminarProduccionSoplado" type="button" data-modal="modalEliminarProduccionSoplado" class="btnIconRojoTxtBlanco btnModal">
                                Eliminar
                                <img src="/public/build/img/icons/papelera.svg" alt="eliminar">
                            </button>
                            <button id="btnEditarProduccionSoplado" type="submit" class="btnIconAzulTxtBlanco">
                                Editar
                                <img src="/public/build/img/icons/editar.svg" alt="editar">
                                <span id="spinner" class="spinner"></span>
                            </button>
                        `:''}
                    </div>
                `;
            })
            .catch((error) => {
                console.error("Error en la solicitud:", error);
                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
                }
                return;
            });
    };

    document.addEventListener('click', function (e) {
        const trAbrir = e.target.closest('.trSelectProduccionSoplado');
        if (trAbrir) {
            const idLineaProduccion = trAbrir.getAttribute('data-id');
            const modalEditarLineaProduccion = document.querySelector('#formEditarProduccionSoplado');
            const modalReporteSoplado = document.querySelector('#formProduccionSoplado');
            let idProduccionSoplado = modalReporteSoplado.querySelector('#idReporteSoplado').value;

            if (!idLineaProduccion || !modalEditarLineaProduccion || !modalReporteSoplado || isNaN(idLineaProduccion) || isNaN(idProduccionSoplado)) {
                alert("No se encontró el ID de la línea de producción o es inválido.");
                return;
            }else{
                let inputIdLineaProduccion = modalEditarLineaProduccion.querySelector('#idLineaProduccionSoplado');
                let inputIdReporteSoplado = modalEditarLineaProduccion.querySelector('#idEncabezadoReporteSoplado');

                if(inputIdLineaProduccion  && inputIdReporteSoplado){
                    inputIdLineaProduccion.value = idLineaProduccion;
                    inputIdReporteSoplado.value = idProduccionSoplado;
                    window.infoLineaProduccionSoplado(idLineaProduccion);
                }else{
                    alert("No se encontró el campo oculto para el ID del encabezado del reporte.");
                    return;
                }
            }
        }
    });
}